import { AppService, ObjectUtil } from '@aperza/util';
import { useLazyQuery } from '@apollo/client';
import { faShoppingCart } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React from 'react';
import Counter from '../common/Counter';
import style from './cartBadge.module.scss';
const QUERY = gql `
  query CartBadgeQuery {
    viewer {
      id
      cartBadge {
        approvalFlag
        totalPurchaseNumber
      }
    }
  }
`;
const appConfig = AppService.appConfig();
const CartBadge = (props) => {
    let url = '#';
    let totalPurchaseNumber;
    const [getData, { loading, error, data, refetch, fetchMore }] = useLazyQuery(QUERY);
    const cartBadge = ObjectUtil.get(props, 'viewer.cartBadge');
    if (cartBadge) {
        url = `https://order${appConfig.baseComDomain}/cart`;
        totalPurchaseNumber = cartBadge.totalPurchaseNumber;
    }
    return (React.createElement("a", { className: style.cartBadge, href: url, target: "_self" },
        React.createElement(FontAwesomeIcon, { icon: faShoppingCart, size: '2x' }),
        totalPurchaseNumber > 0 && React.createElement(Counter, { top: true, count: totalPurchaseNumber })));
};
CartBadge.propTypes = {
    viewer: PropTypes.shape({
        id: PropTypes.string,
        cartBadge: PropTypes.shape({
            totalPurchaseNumber: PropTypes.number,
        }),
    }),
};
export default CartBadge;
